angular.module('component-spinner', [])
    .directive('ctSpinner', ctSpinnerDirective);


function ctSpinnerDirective() {
    return {
        restrict: 'A',
        link: postLink
    };

    function postLink(scope, element, attrs) {
        var $spinner = angular.element(require('./../template/spinner.html'));

        element.addClass('ct-loader');

        scope.$watch(attrs.ctSpinner, function(value) {
            if (value) {
                element.append($spinner);
            } else {
                $spinner.remove();
            }
        });
    }
}



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/loader/directives/directive.js
 ** module id = 168
 ** module chunks = 1
 **/